import { AppointmentType, Country } from '../constants'

interface Reservation {
  appointment_id?: string
  appointment_type: AppointmentType
  created_at: Date
  country: Country
  duration_in_minutes: number
  expires_at: Date
  id: string
  insurance_company?: string
  journey: string
  lead_gid: string
  lead_salesforce_id: string
  recommendation_id: string
  resource_ids: string[]
  start_date: Date
  status: ReservationStatus
  timezone: string
  updated_at: Date
}

interface ReservationConvertRequest {
  country: Country
  customer_salesforce_id: string
  is_manual: boolean
  journey: string
  opportunity_gid: string
  title: string
}

interface ReservationCreateRequest {
  appointment_type: AppointmentType
  country: Country
  duration_in_minutes: number
  insurance_company?: string
  journey: string
  lead_gid: string
  lead_salesforce_id: string
  recommendation_id: string
  resource_ids: string[]
  start_date: Date
  timezone: string
}

interface ReservationsGetManyRequest {
  expires_at?: Date[]
  lead_gid?: string[]
  id?: string[]
  status?: ReservationStatus[]
}

type ReservationResponse = Omit<Reservation, 'created_at' | 'expires_at' | 'start_date' | 'updated_at'> & {
  created_at: string
  expires_at: string
  start_date: string
  updated_at: string
}

enum ReservationStatus {
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  CONVERTED_TO_APPOINTMENT = 'CONVERTED_TO_APPOINTMENT',
  EXPIRED = 'EXPIRED',
}

export type { Reservation, ReservationConvertRequest, ReservationCreateRequest, ReservationsGetManyRequest, ReservationResponse }
export { ReservationStatus }
